import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'fas fa-tachometer-alt',
        url: 'dashboard',
        availableTo: ['SUPER_ADMIN']
    },
    {
        id: 'program',
        title: 'Leads',
        translate: 'MENU.LEAD',
        type: 'item',
        icon: 'fas fa-users',
        url: 'leads',
        availableTo: ['SUPER_ADMIN']
    },
    {
        id: 'blog',
        title: 'Blog',
        translate: 'MENU.BLOG',
        type: 'collapsible',
        // Parent collapsible icon is rendered via the [data-feather] directive
        // by the core menu component, so it must be a Feather icon name.
        icon: 'book-open',
        availableTo: ['SUPER_ADMIN'],
        children: [
            {
                id: 'blog-posts',
                title: 'Posts',
                translate: 'MENU.BLOG_POSTS',
                type: 'item',
                icon: 'fas fa-file-alt',
                url: 'blogs',
                exactMatch: true,
                availableTo: ['SUPER_ADMIN']
            },
            {
                id: 'blog-categories',
                title: 'Categories',
                translate: 'MENU.BLOG_CATEGORIES',
                type: 'item',
                icon: 'fas fa-folder-open',
                url: 'blogs/categories',
                availableTo: ['SUPER_ADMIN']
            },
            {
                id: 'blog-tags',
                title: 'Tags',
                translate: 'MENU.BLOG_TAGS',
                type: 'item',
                icon: 'fas fa-tags',
                url: 'blogs/tags',
                availableTo: ['SUPER_ADMIN']
            }
        ]
    }
];
